import React from 'react'
import { Box, Link, Typography, useTheme, useMediaQuery } from '@mui/material'
import { colors } from 'constants/colors'
import type { Theme } from '@mui/material/styles'

const Footer: React.FC = () => {
  const theme: Theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const bgColor: string = theme.palette.mode === 'dark' ? colors.ALMOST_BLACK : colors.RICH_BLACK

  return (
    <Box
      component='footer'
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        py: { xs: 1, sm: 2 },
        px: { xs: 1, sm: 2 },
        textAlign: 'center',
        backgroundColor: bgColor,
        color: colors.WHITE,
        zIndex: 1000
      }}
    >
      <Typography 
        variant='body2' 
        fontFamily='PremierLeagueRegular'
        sx={{ 
          fontSize: { xs: '0.65rem', sm: '0.875rem' },
          lineHeight: { xs: 1.3, sm: 1.5 }
        }}
      >
        <b>© 2026 by Tomer Chermesh</b> {isMobile ? <br /> : ' // '}All data from the official FPL API (
        <Link
          href='https://medium.com/@frenzelts/fantasy-premier-league-api-endpoints-a-detailed-guide-acbd5598eb19'
          target='_blank'
          rel='noopener noreferrer'
          underline='always'
          color='inherit'
          sx={{ fontSize: 'inherit' }}
        >
          a pretty good guide
        </Link>
        )
      </Typography>
    </Box>
  )
}

export default Footer
